import type { BoardModelKind } from "./kind";

const LABEL_CLASS: Partial<Record<BoardModelKind, string>> = {
  CharacterGroup: "board-model-debug__label--character-group",
  Location: "board-model-debug__label--location",
  LocationGroup: "board-model-debug__label--location-group",
  LocationPrimary: "board-model-debug__label--location-primary",
  LocationSecondary: "board-model-debug__label--location-secondary",
};

export function labelClassForBoardModel(kind: BoardModelKind): string {
  return LABEL_CLASS[kind] ?? "board-model-debug__label";
}
